import { useCallback, useRef, useState } from 'react'
import { useDimensions } from '../useDimensions/useDimensions'

export const useLargestHeight = () => {
  const { landscape } = useDimensions()

  // Use state to trigger the render, but a ref for local
  // checks within the same render cycle.
  const [layout, setLayout] = useState({ landscape, height: 0 })
  const heightRef = useRef(0)

  const onLayout = useCallback(
    (e) => {
      if (landscape !== layout.landscape) {
        heightRef.current = 0
        return setLayout({
          landscape,
          height: 0,
        })
      }
      const { height } = e.nativeEvent.layout
      if (height > heightRef.current) {
        heightRef.current = height
        setLayout({ ...layout, height })
      }
    },
    [landscape, layout],
  )

  return { measuredHeight: layout.height, onLayout }
}
